var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useRef, useEffect } from "react";
import { ConfigContainer } from "./configuration";
import { StatsContainer } from "./stats";
import { toHiragana, toKatakana, isKana } from "wanakana";
import { useKana } from "../lib/kana-dict";
import { createContainer } from "unstated-next";
var initialState = {
    startedOn: new Date(),
    questions: [],
    currentQuestion: 0,
    correct: 0,
    finished: false
};
function useGame() {
    var _a = useState(initialState), game = _a[0], setGame = _a[1];
    var config = ConfigContainer.useContainer();
    var stats = StatsContainer.useContainer();
    var onError = useRef(function () { return null; });
    var kanaDict = useKana();
    var start = function () {
        setGame(startGame(config.get(), kanaDict.Kana));
    };
    var answer = function (input) {
        if (!input || input.length === 0) {
            return;
        }
        setGame(function (g) {
            var correct = isCorrect(input, g);
            if (!correct) {
                onError.current();
            }
            stats.addKana(g.questions[g.currentQuestion], correct);
            return answerQuestion(correct, g);
        });
    };
    var finish = function () {
        var g = finishGame(game);
        stats.add(g);
        setGame(g);
    };
    useEffect(function () {
        if (game.finished && game.currentQuestion === game.questions.length && !game.finishedOn) {
            finish();
        }
    }, [finish, game]);
    return __assign({ start: start, answer: answer, onError: onError }, game);
}
export var GameContainer = createContainer(useGame);
// https://bost.ocks.org/mike/shuffle/
function shuffle(array) {
    var m = array.length, t, i;
    // While there remain elements to shuffle…
    while (m) {
        // Pick a remaining element…
        i = Math.floor(Math.random() * m--);
        // And swap it with the current element.
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}
function answerQuestion(correct, game) {
    if (game.currentQuestion < game.questions.length) {
        var finished = game.currentQuestion === game.questions.length - 1;
        return __assign(__assign({}, game), { currentQuestion: finished ? game.currentQuestion : game.currentQuestion + 1, correct: correct ? game.correct + 1 : game.correct, finished: finished });
    }
    return __assign(__assign({}, game), { correct: correct ? game.correct + 1 : game.correct });
}
function isCorrect(input, game) {
    var q = game.questions[game.currentQuestion];
    var answerKana;
    if (isKana(input)) {
        answerKana = input;
    }
    else {
        answerKana = q.shape === "hiragana" ? toHiragana(input) : toKatakana(input);
    }
    return answerKana === game.questions[game.currentQuestion].char;
}
function finishGame(game) {
    return __assign(__assign({}, game), { currentQuestion: game.currentQuestion + 1, finishedOn: new Date() });
}
function startGame(ids, kana) {
    var options = kana.filter(function (k) { return ids.has(k.id); });
    options = shuffle(options);
    return {
        startedOn: new Date(),
        questions: options,
        currentQuestion: 0,
        correct: 0,
        finished: false
    };
}
//# sourceMappingURL=game.js.map